export const ClientIcon = ({ fill }) => (
  <svg
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.4224 19.3767V18.0434C16.4224 17.3361 16.08 16.6579 15.4705 16.1578C14.861 15.6577 14.0343 15.3767 13.1724 15.3767H6.67236C5.81041 15.3767 4.98376 15.6577 4.37427 16.1578C3.76477 16.6579 3.42236 17.3361 3.42236 18.0434V19.3767"
      stroke={fill}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.4224 19.3767V18.0434C16.4224 17.3361 16.08 16.6579 15.4705 16.1578C14.861 15.6577 14.0343 15.3767 13.1724 15.3767H6.67236C5.81041 15.3767 4.98376 15.6577 4.37427 16.1578C3.76477 16.6579 3.42236 17.3361 3.42236 18.0434V19.3767"
      stroke={fill}
      strokeOpacity="0.2"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.42236 11.3767C11.0792 11.3767 12.4224 10.0336 12.4224 8.37671C12.4224 6.71985 11.0792 5.37671 9.42236 5.37671C7.76551 5.37671 6.42236 6.71985 6.42236 8.37671C6.42236 10.0336 7.76551 11.3767 9.42236 11.3767Z"
      stroke={fill}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.42236 11.3767C11.0792 11.3767 12.4224 10.0336 12.4224 8.37671C12.4224 6.71985 11.0792 5.37671 9.42236 5.37671C7.76551 5.37671 6.42236 6.71985 6.42236 8.37671C6.42236 10.0336 7.76551 11.3767 9.42236 11.3767Z"
      stroke={fill}
      strokeOpacity="0.2"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20.4224 19.3767V18.0138C20.4219 17.4099 20.2253 16.8232 19.8633 16.3459C19.5013 15.8686 18.9944 15.5277 18.4224 15.3767"
      stroke={fill}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20.4224 19.3767V18.0138C20.4219 17.4099 20.2253 16.8232 19.8633 16.3459C19.5013 15.8686 18.9944 15.5277 18.4224 15.3767"
      stroke={fill}
      strokeOpacity="0.2"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.4224 5.37671C15.9945 5.54726 16.5016 5.93467 16.8637 6.47785C17.2258 7.02103 17.4224 7.68909 17.4224 8.37671C17.4224 9.06432 17.2258 9.73238 16.8637 10.2756C16.5016 10.8187 15.9945 11.2062 15.4224 11.3767"
      stroke={fill}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.4224 5.37671C15.9945 5.54726 16.5016 5.93467 16.8637 6.47785C17.2258 7.02103 17.4224 7.68909 17.4224 8.37671C17.4224 9.06432 17.2258 9.73238 16.8637 10.2756C16.5016 10.8187 15.9945 11.2062 15.4224 11.3767"
      stroke={fill}
      strokeOpacity="0.2"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const StaffIcon = ({ fill }) => (
  <svg
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 11.5C14.2091 11.5 16 9.70914 16 7.5C16 5.29086 14.2091 3.5 12 3.5C9.79086 3.5 8 5.29086 8 7.5C8 9.70914 9.79086 11.5 12 11.5Z"
      stroke={fill}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6 21.5V19.5C6 18.4391 6.42143 17.4217 7.17157 16.6716C7.92172 15.9214 8.93913 15.5 10 15.5H14C15.0609 15.5 16.0783 15.9214 16.8284 16.6716C17.5786 17.4217 18 18.4391 18 19.5V21.5"
      stroke={fill}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const DashIcon = ({ fill }) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6 1H2C1.44772 1 1 1.44772 1 2V6C1 6.55228 1.44772 7 2 7H6C6.55228 7 7 6.55228 7 6V2C7 1.44772 6.55228 1 6 1Z"
      stroke={fill}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6 1H2C1.44772 1 1 1.44772 1 2V6C1 6.55228 1.44772 7 2 7H6C6.55228 7 7 6.55228 7 6V2C7 1.44772 6.55228 1 6 1Z"
      stroke={fill}
      strokeOpacity="0.2"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16 1H12C11.4477 1 11 1.44772 11 2V6C11 6.55228 11.4477 7 12 7H16C16.5523 7 17 6.55228 17 6V2C17 1.44772 16.5523 1 16 1Z"
      stroke={fill}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16 1H12C11.4477 1 11 1.44772 11 2V6C11 6.55228 11.4477 7 12 7H16C16.5523 7 17 6.55228 17 6V2C17 1.44772 16.5523 1 16 1Z"
      stroke={fill}
      strokeOpacity="0.2"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6 11H2C1.44772 11 1 11.4477 1 12V16C1 16.5523 1.44772 17 2 17H6C6.55228 17 7 16.5523 7 16V12C7 11.4477 6.55228 11 6 11Z"
      stroke={fill}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6 11H2C1.44772 11 1 11.4477 1 12V16C1 16.5523 1.44772 17 2 17H6C6.55228 17 7 16.5523 7 16V12C7 11.4477 6.55228 11 6 11Z"
      stroke={fill}
      strokeOpacity="0.2"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16 11H12C11.4477 11 11 11.4477 11 12V16C11 16.5523 11.4477 17 12 17H16C16.5523 17 17 16.5523 17 16V12C17 11.4477 16.5523 11 16 11Z"
      stroke={fill}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16 11H12C11.4477 11 11 11.4477 11 12V16C11 16.5523 11.4477 17 12 17H16C16.5523 17 17 16.5523 17 16V12C17 11.4477 16.5523 11 16 11Z"
      stroke={fill}
      strokeOpacity="0.2"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const AccMgtIcon = ({ fill }) => (
  <svg
    width="20"
    height="18"
    viewBox="0 0 20 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3 1.5H7L10 4.5H17C17.5304 4.5 18.0391 4.71071 18.4142 5.08579C18.7893 5.46086 19 5.96957 19 6.5V14.5C19 15.0304 18.7893 15.5391 18.4142 15.9142C18.0391 16.2893 17.5304 16.5 17 16.5H3C2.46957 16.5 1.96086 16.2893 1.58579 15.9142C1.21071 15.5391 1 15.0304 1 14.5V3.5C1 2.96957 1.21071 2.46086 1.58579 2.08579C1.96086 1.71071 2.46957 1.5 3 1.5"
      stroke={fill}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3 1.5H7L10 4.5H17C17.5304 4.5 18.0391 4.71071 18.4142 5.08579C18.7893 5.46086 19 5.96957 19 6.5V14.5C19 15.0304 18.7893 15.5391 18.4142 15.9142C18.0391 16.2893 17.5304 16.5 17 16.5H3C2.46957 16.5 1.96086 16.2893 1.58579 15.9142C1.21071 15.5391 1 15.0304 1 14.5V3.5C1 2.96957 1.21071 2.46086 1.58579 2.08579C1.96086 1.71071 2.46957 1.5 3 1.5"
      stroke={fill}
      strokeOpacity="0.2"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const SettingsIcon = ({ fill }) => (
  <svg
    width="20"
    height="21"
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.325 2.817C8.751 1.061 11.249 1.061 11.675 2.817C11.7389 3.0808 11.8642 3.32578 12.0407 3.532C12.2172 3.73822 12.4399 3.89985 12.6907 4.00375C12.9414 4.10764 13.2132 4.15085 13.4838 4.12987C13.7544 4.10889 14.0162 4.0243 14.248 3.883C15.791 2.943 17.558 4.709 16.618 6.253C16.4769 6.48466 16.3924 6.74634 16.3715 7.01677C16.3506 7.28721 16.3938 7.55877 16.4975 7.80938C16.6013 8.05999 16.7627 8.28258 16.9687 8.45905C17.1747 8.63553 17.4194 8.76091 17.683 8.825C19.439 9.251 19.439 11.749 17.683 12.175C17.4192 12.2389 17.1742 12.3642 16.968 12.5407C16.7618 12.7172 16.6001 12.9399 16.4963 13.1907C16.3924 13.4414 16.3491 13.7132 16.3701 13.9838C16.3911 14.2544 16.4757 14.5162 16.617 14.748C17.557 16.291 15.791 18.058 14.247 17.118C14.0153 16.9769 13.7537 16.8924 13.4832 16.8715C13.2128 16.8506 12.9412 16.8938 12.6906 16.9975C12.44 17.1013 12.2174 17.2627 12.0409 17.4687C11.8645 17.6747 11.7391 17.9194 11.675 18.183C11.249 19.939 8.751 19.939 8.325 18.183C8.26108 17.9192 8.13578 17.6742 7.95929 17.468C7.7828 17.2618 7.56011 17.1001 7.30935 16.9963C7.05859 16.8924 6.78683 16.8491 6.51621 16.8701C6.24559 16.8911 5.98375 16.9757 5.752 17.117C4.209 18.057 2.442 16.291 3.382 14.747C3.5231 14.5153 3.60755 14.2537 3.62848 13.9832C3.64942 13.7128 3.60624 13.4412 3.50247 13.1906C3.3987 12.94 3.23726 12.7174 3.03127 12.5409C2.82529 12.3645 2.58056 12.2391 2.317 12.175C0.561 11.749 0.561 9.251 2.317 8.825C2.5808 8.76108 2.82578 8.63578 3.032 8.45929C3.23822 8.2828 3.39985 8.06011 3.50375 7.80935C3.60764 7.55859 3.65085 7.28683 3.62987 7.01621C3.60889 6.74559 3.5243 6.48375 3.383 6.252C2.443 4.709 4.209 2.942 5.753 3.882C6.753 4.49 8.049 3.952 8.325 2.817Z"
      stroke={fill}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.325 2.817C8.751 1.061 11.249 1.061 11.675 2.817C11.7389 3.0808 11.8642 3.32578 12.0407 3.532C12.2172 3.73822 12.4399 3.89985 12.6907 4.00375C12.9414 4.10764 13.2132 4.15085 13.4838 4.12987C13.7544 4.10889 14.0162 4.0243 14.248 3.883C15.791 2.943 17.558 4.709 16.618 6.253C16.4769 6.48466 16.3924 6.74634 16.3715 7.01677C16.3506 7.28721 16.3938 7.55877 16.4975 7.80938C16.6013 8.05999 16.7627 8.28258 16.9687 8.45905C17.1747 8.63553 17.4194 8.76091 17.683 8.825C19.439 9.251 19.439 11.749 17.683 12.175C17.4192 12.2389 17.1742 12.3642 16.968 12.5407C16.7618 12.7172 16.6001 12.9399 16.4963 13.1907C16.3924 13.4414 16.3491 13.7132 16.3701 13.9838C16.3911 14.2544 16.4757 14.5162 16.617 14.748C17.557 16.291 15.791 18.058 14.247 17.118C14.0153 16.9769 13.7537 16.8924 13.4832 16.8715C13.2128 16.8506 12.9412 16.8938 12.6906 16.9975C12.44 17.1013 12.2174 17.2627 12.0409 17.4687C11.8645 17.6747 11.7391 17.9194 11.675 18.183C11.249 19.939 8.751 19.939 8.325 18.183C8.26108 17.9192 8.13578 17.6742 7.95929 17.468C7.7828 17.2618 7.56011 17.1001 7.30935 16.9963C7.05859 16.8924 6.78683 16.8491 6.51621 16.8701C6.24559 16.8911 5.98375 16.9757 5.752 17.117C4.209 18.057 2.442 16.291 3.382 14.747C3.5231 14.5153 3.60755 14.2537 3.62848 13.9832C3.64942 13.7128 3.60624 13.4412 3.50247 13.1906C3.3987 12.94 3.23726 12.7174 3.03127 12.5409C2.82529 12.3645 2.58056 12.2391 2.317 12.175C0.561 11.749 0.561 9.251 2.317 8.825C2.5808 8.76108 2.82578 8.63578 3.032 8.45929C3.23822 8.2828 3.39985 8.06011 3.50375 7.80935C3.60764 7.55859 3.65085 7.28683 3.62987 7.01621C3.60889 6.74559 3.5243 6.48375 3.383 6.252C2.443 4.709 4.209 2.942 5.753 3.882C6.753 4.49 8.049 3.952 8.325 2.817Z"
      stroke={fill}
      strokeOpacity="0.2"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10 13.5C11.6569 13.5 13 12.1569 13 10.5C13 8.84315 11.6569 7.5 10 7.5C8.34315 7.5 7 8.84315 7 10.5C7 12.1569 8.34315 13.5 10 13.5Z"
      stroke={fill}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10 13.5C11.6569 13.5 13 12.1569 13 10.5C13 8.84315 11.6569 7.5 10 7.5C8.34315 7.5 7 8.84315 7 10.5C7 12.1569 8.34315 13.5 10 13.5Z"
      stroke={fill}
      strokeOpacity="0.2"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const LogIcon = ({ fill }) => (
  <svg
    width="17"
    height="15"
    viewBox="0 0 17 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5 1.5H16"
      stroke={fill}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5 1.5H16"
      stroke={fill}
      strokeOpacity="0.2"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5 7.5H16"
      stroke={fill}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5 7.5H16"
      stroke={fill}
      strokeOpacity="0.2"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5 13.5H16"
      stroke={fill}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5 13.5H16"
      stroke={fill}
      strokeOpacity="0.2"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1 1.5V1.51"
      stroke={fill}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1 1.5V1.51"
      stroke={fill}
      strokeOpacity="0.2"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1 7.5V7.51"
      stroke={fill}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1 7.5V7.51"
      stroke={fill}
      strokeOpacity="0.2"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1 13.5V13.51"
      stroke={fill}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1 13.5V13.51"
      stroke={fill}
      strokeOpacity="0.2"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
